import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { CtaRow, GhostCta, PrimaryCta, StoreBadges, useLanding } from '@/components/Landing/LandingKit';
import { AboutBody, AboutSection, AboutTitle } from './AboutKit';

function AboutClosing() {
  const { c, isXS, isCompact } = useLanding();
  return (
    <AboutSection label="Try Gab AI">
      <View style={{ flexDirection: isCompact ? 'column' : 'row', alignItems: isCompact ? 'stretch' : 'center', justifyContent: 'space-between', gap: 26 }}>
        <View>
          <AboutTitle>See what you can make.</AboutTitle>
          <AboutBody style={{ marginTop: 14 }}>Start free. Get the Work Agent with Plus.</AboutBody>
        </View>
        <CtaRow><PrimaryCta restrained label="Get started free" full={isXS} /><GhostCta label="View plans" href="/pricing" /></CtaRow>
      </View>
      <View style={{ marginTop: 36, paddingTop: 26, borderTopWidth: 1, borderTopColor: c.rule, flexDirection: isCompact ? 'column' : 'row', alignItems: isCompact ? 'flex-start' : 'center', justifyContent: 'space-between', gap: 20 }}>
        <View style={{ gap: 8 }}>
          <Text style={{ color: c.inkSoft, fontSize: 13, lineHeight: 21 }}>On the web, iPhone, iPad, Mac, and Android.</Text>
          <Text style={{ color: c.muted, fontSize: 12, lineHeight: 20 }}>Made in USA · Christ is King</Text>
        </View>
        <StoreBadges scale={0.85} />
      </View>
    </AboutSection>
  );
}

export default React.memo(AboutClosing);
